module.exports = {
    item:"brf-key list-group-item-heading",
    itemInner:"brf-value list-group-item-text",
    buttonsClass:'btn-group pull-right',
    buttonCancel: 'btn btn-default',
    buttonSave:'btn-primary btn'
}


/** WEBPACK FOOTER **
 ** ./src/styles/Mixed-style.js
 **/